import { render } from "./assureurTemplate.vue?vue&type=template&id=5257f26b&scoped=true"
import script from "./assureurTemplate.vue?vue&type=script&lang=js"
export * from "./assureurTemplate.vue?vue&type=script&lang=js"

import "./assureurTemplate.vue?vue&type=style&index=0&id=5257f26b&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-config-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5257f26b"]])

export default __exports__